export default {"src":"/_next/static/media/PaymentMethodsLight.ab5544fb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};